import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'asesoria_cliente_id';

export function useClienteSession() {
  const [clienteId, setClienteIdState] = useState<number>(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? parseInt(raw, 10) : 0;
      return Number.isNaN(parsed) ? 0 : parsed;
    } catch {
      return 0;
    }
  });

  const setClienteId = useCallback((id: number) => {
    try {
      if (id > 0) {
        localStorage.setItem(STORAGE_KEY, String(id));
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch {
      // ignore localStorage errors
    }
    setClienteIdState(id);
  }, []);

  // Listen to storage changes from other tabs
  useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) {
        const parsed = e.newValue ? parseInt(e.newValue, 10) : 0;
        setClienteIdState(Number.isNaN(parsed) ? 0 : parsed);
      }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  return { clienteId, setClienteId };
}

export function getClienteSessionId(): number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? parseInt(raw, 10) : 0;
    return Number.isNaN(parsed) ? 0 : parsed;
  } catch {
    return 0;
  }
}

export function clearClienteSession() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}